import styled from 'styled-components';

const StyledCardContent = styled.div `
  padding: 0 32px 40px;

  ${props => props.theme.media.tabletPortraitDown} {
    padding: 0 24px 40px;

    button {
      width: 100%;
    }
  }

  > img {
    border-radius: ${props => props.theme.borderRadii.large};
  }
`;

export { StyledCardContent };
